
const install = () => {

  if (window.ioGetBlackbox) {
    return;
  }

  window.io_install_stm = false;
  window.io_exclude_stm = 12;
  window.io_install_flash = false;
  window.io_min_flash_version = 9999;
  window.io_enable_rip = true;

  if (!document.getElementById('wholescale-snare')) {
    const script = document.createElement('script');
    script.src = 'https://cdn-live.wholescale.net/snare.js';
    script.defer = true;
    script.id = 'wholescale-snare';
    document.body.appendChild(script);
  }
};

const blackbox = () => {

  let value = undefined;

  if (typeof window.ioGetBlackbox === 'function') {
    const data = window.ioGetBlackbox();
    if (data.finished) {
      value = data.blackbox;
    }
  }

  return value;
};

const wholescale = {
  install,
  blackbox,
};

export default wholescale;